export default "__VITE_ASSET__C81e1h2F__"